/* ════════════════════════════════════════════════
   éclat Product — core behaviours shared by every section.
   Lifted verbatim from the original single-file build; the only additions are
   null-guards, so a section can be removed in the Theme Editor without
   throwing and taking the rest of the page down with it.
   Loaded with `defer`, so it runs after the whole document is parsed —
   exactly like the original <script> at the end of <body>.
   ════════════════════════════════════════════════ */
(function () {
  'use strict';
  if (window.__eclatProductCore) return;
  window.__eclatProductCore = true;

  var RM = matchMedia('(prefers-reduced-motion: reduce)').matches;
  window.__eclatProductRM = RM;

  document.addEventListener('error', function (e) {
    if (e.target && e.target.tagName === 'IMG') e.target.classList.add('err');
  }, true);

  /* ── split headline into words ── */
  function splitWords(root) {
    (root || document).querySelectorAll('.words').forEach(function (el) {
      if (el.dataset.eclatProductSplit) return;
      el.dataset.eclatProductSplit = '1';
      var frag = document.createDocumentFragment(), i = 0;
      el.childNodes.forEach(function (n) {
        if (n.nodeType === 3) {
          n.textContent.split(/(\s+)/).forEach(function (w) {
            if (!w.trim()) { frag.appendChild(document.createTextNode(w)); return; }
            var s = document.createElement('span'); s.textContent = w;
            s.style.transitionDelay = (i++ * 0.07) + 's'; frag.appendChild(s);
          });
        } else {
          n.style.transitionDelay = (i++ * 0.07) + 's';
          var wrap = document.createElement('span');
          wrap.style.transitionDelay = n.style.transitionDelay;
          wrap.appendChild(n.cloneNode(true)); frag.appendChild(wrap);
        }
      });
      el.innerHTML = ''; el.appendChild(frag);
    });
  }

  /* ── counters ── */
  function fmtN(v) { return String(v).replace(/\B(?=(\d{3})+(?!\d))/g, '.'); }
  function count(el) {
    if (RM) { el.textContent = fmtN(+el.dataset.to); return; }
    var to = +el.dataset.to, t0 = null, dur = 1500;
    function step(ts) {
      if (!t0) t0 = ts;
      var p = Math.min((ts - t0) / dur, 1), e = 1 - Math.pow(1 - p, 3);
      el.textContent = fmtN(Math.round(to * e));
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  /* ── reveal observer ── */
  var seen = new WeakSet(), io = null;
  function activate(el) {
    if (!el || seen.has(el)) return; seen.add(el);
    el.classList.add('in');
    el.querySelectorAll('.cnt').forEach(count);
    if (el.classList.contains('cal')) fillCal(el);
  }
  function fillCal() {}

  function observe(root) {
    var targets = (root || document).querySelectorAll('.rv,.rz,.words,.cal,.mbar');
    if ('IntersectionObserver' in window && !RM) {
      if (!io) {
        io = new IntersectionObserver(function (es) {
          es.forEach(function (e) { if (e.isIntersecting) { activate(e.target); io.unobserve(e.target); } });
        }, { rootMargin: '0px 0px -8% 0px', threshold: .08 });
      }
      targets.forEach(function (el) { io.observe(el); });
    } else {
      targets.forEach(function (el) {
        el.classList.add('in');
        el.querySelectorAll('.cnt').forEach(function (c) { c.textContent = c.dataset.to; });
      });
      var c0 = document.getElementById('cal'); if (c0) c0.classList.add('in');
    }
  }

  function boot(root) {
    splitWords(root);
    observe(root);
  }

  /* exposed so the Theme Editor can re-bind a section after it is re-rendered */
  window.eclatProductReveal = boot;
  window.eclatProductActivate = activate;

  boot(document);
  requestAnimationFrame(function () { activate(document.getElementById('hero')); });

  document.addEventListener('shopify:section:load', function (e) {
    boot(e.target);
    requestAnimationFrame(function () { activate(document.getElementById('hero')); });
  });
})();
